"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickupTimes = void 0;
exports.PickupTimes = {
    selectAPickupTime: 'Select a pick up time',
    selectADeliveryTime: 'Select a delivery time',
    immediate: 'Immediate',
};
//# sourceMappingURL=PickupTimes.js.map